// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__yZ+9X","inner":"Modal_inner__8Bpp6"};